import React, { useState, useEffect } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../Auth/AuthContext';
import { CheckCircle, MoreVertical, Globe } from "lucide-react";
import DataTable from 'react-data-table-component';
import PublisherApiService from '../../ApiServices/PublisherApiService/PublisherApiService';
import adsTxtApiService from '../../ApiServices/AdsTxtApiService/AdTxtApiService';


const AdscodeTable = () => {
    const filetype = "AdCodeTxt";
    const [fileContent, setFileContent] = useState("");
    const [adsCodes, setAdsCodes] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState(adsCodes);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const showAdsCode = () => {
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
    };


    const Auth = useAuth();
    const user = Auth.authState.user;
    const isAdmin = Auth.authState.roles === "Admin";

    useEffect(() => {
        if (user && user.id) {
            fetchAdsCodes();
            fetchFileContent();
        }
    }, [user]);

    const fetchFileContent = async () => {
        try {
            let fileTxt = await adsTxtApiService.getAdFile(filetype);
            setFileContent(fileTxt);
        } catch (error) {
            console.error("Error fetching ad file:", error);
            toast.error("Failed to load ads.txt");
        }
    };
    const fetchAdsCodes = async () => {
        setLoading(true);
        try {
            const response = await PublisherApiService.GetAdsCodes(user.id);
            setAdsCodes(response.data || []);
            setFilteredData(response.data || []);
        } catch (error) {
            toast.error('Failed to fetch ad codes.');
        } finally {
            setLoading(false);
        }
    };

    const headers = [
        { label: "Webiste/App", icon: <Globe size={16} />, selector: "weborApp" },
        { label: "Assigned date", icon: <CheckCircle size={16} />, selector: "assignedDate" },
        { label: "Actions", icon: <MoreVertical size={16} />, selector: "" }
    ];
    const columns = headers.map(({ label, icon, selector }) => {
        if (label === "Actions") {
            return {
                name: (
                    <div className="flex items-center">
                        {icon}
                        <span className="ml-2">{label}</span>
                    </div>
                ),
                cell: (row) =>
                (
                    <button
                        onClick={() => showAdsCode()}
                        className="btn bg-blue-500 px-4 py-2 text-white rounded-md"
                    >
                        Show Adscodes
                    </button>
                ),
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
            };
        } else {
            return {
                name: (
                    <div className="flex items-center">
                        {icon}
                        <span className="ml-2">{label}</span>
                    </div>
                ),
                selector: (row) =>
                    selector === "AssignedDate"
                        ? new Date(row[selector]).toLocaleDateString()
                        : row[selector]?.toString() ?? "",
                sortable: true,
            };
        }
    });

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
        const filteredResults = adsCodes.filter((item) =>
            Object.values(item).some((val) =>
                val?.toString().toLowerCase().includes(value)
            )
        );
        setFilteredData(filteredResults);
    };
    // Custom Styles
    const customStyles = {
        headRow: {
            style: {
                background: "linear-gradient(to right, #9333EA, #EC4899)",
            },
        },
        headCells: {
            style: {
                color: "#fff", // Equivalent to text-white
                fontWeight: "bold",
                fontSize: "14px",
            },
        },
    };

    return (
        <div className="p-5">
            <ToastContainer />
            <div className="bg-white shadow-lg rounded-lg p-5">
                <div className="flex justify-between items-center mb-4">
                    <input
                        type="text"
                        className="border border-gray-300 px-4 py-2 rounded-md"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={handleSearch}
                    />
                </div>

                <div className="overflow-x-auto rounded-lg border border-gray-200">
                    <DataTable
                        columns={columns}
                        data={filteredData}
                        pagination
                        highlightOnHover
                        striped
                        responsive
                        className="min-w-full bg-white border-collapse"
                        customStyles={customStyles}
                    />
                </div>
            </div>
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                    <div className="bg-white rounded-lg shadow-lg max-w-3xl w-full p-5 relative">
                        <button
                            className="absolute top-2 right-3 text-gray-600 hover:text-black text-xl font-bold"
                            onClick={closeModal}
                        >
                            &times;
                        </button>
                        <h2 className="text-xl font-semibold mb-4">Google Adformat</h2>
                        <div className="overflow-x-auto border border-gray-200 p-3 bg-gray-50 rounded-lg max-h-[400px]">
                            <pre className="whitespace-pre-wrap text-gray-800 max-w-full md:max-w-3xl overflow-x-auto">
                                {fileContent}
                            </pre>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
};

export default AdscodeTable;
